<template>
  <div>
    <filter-item v-if="this.$store.getters.authUser.can_access_all_leads">
      <filter-users
        store-module="leads"
        :filter-name="filterName"
      ></filter-users>
    </filter-item>

    <filter-item>
      <filter-pipeline-state
        :filter-name="filterName"
        store-module="leads"
      ></filter-pipeline-state>
    </filter-item>

    <filter-item v-show="statusStates.length !== 0">
      <filter-statuses-multiple
        :filter-name="filterName"
        store-module="leads"
        :statuses-name="statusesName"
        :status-states="statusStates"
      ></filter-statuses-multiple>
    </filter-item>

    <filter-item v-show="isFollowUpIncluded">
      <filter-sequences
        label="Follow Up Sequences"
        store-module="leads"
        :filter-name="filterName"
      ></filter-sequences>
    </filter-item>

    <filter-item>
      <filter-sources-selector
        store-module="leads"
        :filter-name="filterName"
        include-no-source
      ></filter-sources-selector>
    </filter-item>

    <filter-item>
      <filter-time-frames
        store-module="leads"
        :filter-name="filterName"
      ></filter-time-frames>
    </filter-item>

    <filter-item>
      <filter-campaigns
        store-module="leads"
        :filter-name="filterName"
      ></filter-campaigns>
    </filter-item>

    <filter-item>
      <filter-exist-strategies
        store-module="leads"
        :filter-name="filterName"
      ></filter-exist-strategies>
    </filter-item>

    <filter-item>
      <filter-temperatures
        store-module="leads"
        :filter-name="filterName"
      ></filter-temperatures>
    </filter-item>

    <filter-item>
      <filter-deal-probability-score
        store-module="leads"
        :filter-name="filterName"
      ></filter-deal-probability-score>
    </filter-item>

    <filter-item>
      <form-field-select
        label="Tasks"
        v-model="filterTasks"
      >
        <option :value="null">No filter</option>
        <option :value="true">Leads Has Tasks</option>
        <option :value="false">Leads Doesn't Have Tasks</option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <form-field-select
        label="Task Tag"
        v-model="filterTaskTag"
      >
        <option :value="null">All Tags</option>
        <option
          v-for="option in taskTags"
          :value="option.id"
          :key="option.id"
        >{{ option.label }}
        </option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <filter-postcode
        :filter-name="filterName"
        store-module="leads"
      ></filter-postcode>
    </filter-item>

    <filter-item>
      <filter-beds
        :filter-name="filterName"
        store-module="leads"
      ></filter-beds>
    </filter-item>

    <filter-item>
      <filter-baths
        :filter-name="filterName"
        store-module="leads"
      ></filter-baths>
    </filter-item>

    <filter-item>
      <filter-sqft
        :filter-name="filterName"
        store-module="leads"
      ></filter-sqft>
    </filter-item>

    <filter-item>
      <filter-lot-size
        :filter-name="filterName"
        store-module="leads"
      ></filter-lot-size>
    </filter-item>

    <filter-item>
      <filter-year-built
        :filter-name="filterName"
        store-module="leads"
      ></filter-year-built>
    </filter-item>
  </div>
</template>

<script>

import {ENUMS} from "../../../services/enums";

export default {
  name: "LeadsFilters",
  props: {
    filterName: {
      type: String,
      default: "leads"
    }
  },
  data() {
    return {
      statusesName: 'statuses',
    }
  },
  computed: {
    statusStates() {
      return this.$store.getters["leads/filters"](this.filterName).recordStates
    },
    taskTags() {
      return this.$store.getters.taskTags
    },
    isFollowUpIncluded() {
      const isIncluded = this.statusStates.includes(ENUMS.StatusStateEnum.FollowUp.value)

      /**
       * resets the FUS Sequence filter value when "Follow Up" state is not selected
       * this is to avoid including the filter when it's not actually included
       */
      if (!isIncluded) {
        this.$store.commit("leads/setOneFilter", [
          this.filterName,
          "sequences",
          null
        ]);
      }

      return isIncluded
    },
    filterTasks: {
      get() {
        return this.$store.getters["leads/filters"](this.filterName).hasTasks;
      },
      set(value) {
        this.$store.commit("leads/setOneFilter", [
          this.filterName,
          "hasTasks",
          value
        ]);
      }
    },
    filterTaskTag: {
      get() {
        return this.$store.getters["leads/filters"](this.filterName).taskTag;
      },
      set(value) {
        this.$store.commit("leads/setOneFilter", [
          this.filterName,
          "taskTag",
          value
        ]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.filter_item {
  padding: 0 8px 12px !important;
}
</style>
